import { useTranslation } from 'react-i18next'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const useMeterSearchField = () => {
  const { t } = useTranslation()
  const isPulse = usePulseScope()

  const fieldText = (key: string) => (isPulse ? { label: t(key) } : { placeholder: t(key) })

  return { isPulse, fieldText }
}

export default useMeterSearchField
